import { Component, OnInit } from '@angular/core';
import { E5coreUiAssignUserBaseComponent } from './e5core-ui-work-assign-user-base';

@Component({
  selector: 'e5core-ui-work-assign-user-box',
  templateUrl: './e5core-ui-work-assign-user-box.component.html',
  styleUrls: ['./e5core-ui-work-assign-user-box.component.css'],
  providers: [ {provide: E5coreUiAssignUserBaseComponent, useExisting: E5coreUiAssignUserBoxComponent }]
})
export class E5coreUiAssignUserBoxComponent extends E5coreUiAssignUserBaseComponent implements OnInit{
}